import React from 'react';

import FormattedMessage from 'components/formatted-message';

import { getLauncherKey } from '../nav-link-utils';
import { LAUNCHER_LABEL_IDS } from '../launcher-config';
import styles from '../app-launcher.module.css';

const pinCheckboxId = to => `header-pin-${encodeURIComponent(to)}`;

export const LauncherCustomizeList = ({ links, activePins, onTogglePin }) => (
    <div className={styles.overflowList}>
        <div className={styles.customizeHint}>
            <FormattedMessage id="launcher.customize.hint" />
        </div>
        {links.map(link => {
            const labelId = LAUNCHER_LABEL_IDS[getLauncherKey(link.to)];
            const checkboxId = pinCheckboxId(link.to);

            return (
                <label className={styles.customizeItem} key={link.to} htmlFor={checkboxId}>
                    <input
                        id={checkboxId}
                        type="checkbox"
                        checked={activePins.includes(link.to)}
                        onChange={event => onTogglePin(link.to, event.target.checked)}
                    />
                    {labelId ? <FormattedMessage id={labelId} /> : link.children}
                </label>
            );
        })}
    </div>
);
